<script setup>
  import { ref, computed, defineAsyncComponent, onErrorCaptured } from 'vue';
  import { useTidesStore } from '@/stores/TidesStore';
  import { useMediaQuery } from '@/composables/useMediaQuery';
  import CompleteReportDataContainerSection from '@/components/CompleteReportDataContainerSection.vue';
  import DataContainer from '@/components/DataContainer.vue';
  import Bugsnag from '@bugsnag/js';

  const NearbyTidesContent = defineAsyncComponent(() => import('@/components/NearbyTidesContent.vue')); 

  const props = defineProps({
    upgrade: {
      type: Array,
      required: true
    },
    settings: {
      type: Object,
      required: false
    }
  });

  const isDesktop = useMediaQuery('(min-width: 840px)');

  const content = ref(null);
  const containerTitle = ref("Tides");
  const calendarWeeks = ref(1);

  const minHeight = computed(() => {
    if (isDesktop.value) {
      return calendarWeeks.value === 1 ? '815' : '1127';
    }

    return calendarWeeks.value === 1 ? '790' : '1240';
  });

  function handleCalendarViewChanged(e) {
    calendarWeeks.value = e.weeks.length;
  }
  
  onErrorCaptured((e) => {
    console.warn(e);
    Bugsnag.notify(e);

    return false;
  })    
</script>

<template>
    <CompleteReportDataContainerSection
      v-model:content="content"
      sectionId="tides"
      :title="containerTitle"
      containerTypeId="Tides"
      :minHeight="`${minHeight}px`"
      :metaActions="false"
      >
      <template #content="{ isVisible }">
        
        <DataContainer
          style="width: 100%; height: 100%;"
          contentType="tides"
        >
          <NearbyTidesContent
             v-if="isVisible"
             @calendarViewChanged="handleCalendarViewChanged"
             :settings="props.settings"
          />
        </DataContainer>
      </template>
    </CompleteReportDataContainerSection>
</template>